/* eslint-disable no-duplicate-case */
import { docodeHexResponse } from '../../../_common/common.utils';
import BankTransactionType from './bankTranscation.types';

const INITIAL_STATE = {
	bankTransactionExcelResp: null,
	bankTransactionExcelArr: [],
	addBankTransactionDetailsResponse: null,
	updateBankTransactionDetailsResponse: null,
	getBankTransactionListResponse: null,
	getBankTransactionListArr: [],
	fetchBankTransactionDetailsResponse: null,
	fetchBankTransactionDetailsArr: [],
	deleteBankTransactionDetailsResponse: null,
	getModelValuesArr: [],
	getModelValuesResponse: null,
	getCeckBranchEODArr: [],
	getCeckBranchEODResponse: null,
	transactionApproveResponseList: null,
};

const bankTransactionReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case BankTransactionType.BANK_TRANSACTION_EXCEL_SUCCESS:
			return {
				...state,
				bankTransactionExcelResp: action.payload,
				bankTransactionExcelArr: docodeHexResponse(
					action.payload,
					'BankTransactionExcelKey',
				),
			};

		case BankTransactionType.BANK_TRANSACTION_EXCEL_FAILURE:
			return { ...state, bankTransactionExcelResp: action.payload };

		case BankTransactionType.BANK_TRANSACTION_EXCEL_RESPONSE_CHANGED:
			return { ...state, bankTransactionExcelResp: null };

		/** ***************** ADD BANK TRANSACTION DETAILS START *********************** */
		case BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, addBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_FAILURE:
			return { ...state, addBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.ADD_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, addBankTransactionDetailsResponse: null };
		/** ***************** ADD BANK TRANSACTION DETAILS END *********************** */

		/** ***************** UPDATE BANK TRANSACTION DETAILS START *********************** */
		case BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, updateBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_FAILURE:
			return { ...state, updateBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.UPDATE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateBankTransactionDetailsResponse: null };
		/** ***************** UPDATE BANK_TRANSACTION DETAILS END *********************** */

		/** ***************** GET BANK TRANSACTION DETAILS START *********************** */
		case BankTransactionType.GET_BANK_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				getBankTransactionListResponse: action.payload,
				getBankTransactionListArr: docodeHexResponse(
					action.payload,
					'GetCompanyTranscationEntryListKey',
				),
			};

		case BankTransactionType.GET_BANK_TRANSACTION_LIST_FAILURE:
			return { ...state, getBankTransactionListResponse: action.payload };

		case BankTransactionType.GET_BANK_TRANSACTION_LIST_RESPONSE_CHANGED:
			return { ...state, getBankTransactionListResponse: null };
		/** ***************** GET BANK TRANSACTION DETAILS END *********************** */

		/** ***************** FETCH BANK TRANSACTION DETAILS START *********************** */
		case BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_SUCCESS:
			return {
				...state,
				fetchBankTransactionDetailsResponse: action.payload,
				fetchBankTransactionDetailsArr: docodeHexResponse(
					action.payload,
					'FetchParticularTransactionKey',
				),
			};

		case BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_FAILURE:
			return { ...state, fetchBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.FETCH_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchBankTransactionDetailsResponse: null,
				fetchBankTransactionDetailsArr: [],
			};
		/** ***************** FETCH BANK TRANSACTION DETAILS END *********************** */

		/** ***************** DELETE BANK TRANSACTION DETAILS START *********************** */
		case BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, deleteBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_FAILURE:
			return { ...state, deleteBankTransactionDetailsResponse: action.payload };

		case BankTransactionType.DELETE_BANK_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteBankTransactionDetailsResponse: null };
		/** ***************** DELETE BANK TRANSACTION DETAILS END *********************** */

		/** ***************** GET MODEL VALUES DETAILS START *********************** */
		case BankTransactionType.GET_VALUES_MODEL_SUCCESS:
			return {
				...state,
				getModelValuesResponse: action.payload,
				getModelValuesArr: docodeHexResponse(action.payload, 'GetModelValuesKey'),
			};

		case BankTransactionType.GET_VALUES_MODEL_FAILURE:
			return { ...state, getModelValuesResponse: action.payload };

		case BankTransactionType.GET_VALUES_MODEL_RESPONSE_CHANGED:
			return { ...state, getModelValuesResponse: null };
		/** ***************** GETMODEL VALUESDETAILS END *********************** */

		/** ***************** CHECK BRANCH EOD DETAILS DETAILS START *********************** */
		case BankTransactionType.CHECK_BRANCH_EOD_SUCCESS:
			return {
				...state,
				getCeckBranchEODResponse: action.payload,
				getCeckBranchEODArr: docodeHexResponse(
					action.payload,
					'GetParticularBranchEODListKey',
				),
			};

		case BankTransactionType.CHECK_BRANCH_EOD_FAILURE:
			return { ...state, getCeckBranchEODResponse: action.payload };

		case BankTransactionType.CHECK_BRANCH_EOD_RESPONSE_CHANGED:
			return { ...state, getCeckBranchEODResponse: null };
		/** ***************** CHECK BRANCH EOD DETAILS END *********************** */

		/** *****************TRANSACTION APPROVED DETAILS START *********************** */
		case BankTransactionType.SELECTED_TRANSACTION_APPROVE_SUCCESS:
			return { ...state, transactionApproveResponseList: action.payload };

		case BankTransactionType.SELECTED_TRANSACTION_APPROVE_FAILURE:
			return { ...state, transactionApproveResponseList: action.payload };

		case BankTransactionType.SELECTED_TRANSACTION_APPROVE_CHANGED:
			return { ...state, transactionApproveResponseList: null };
		/** ***************** TRANSACTION APPROVED DETAILS END *********************** */

		default:
			return state;
	}
};

export default bankTransactionReducer;
